<div class="tw-p-4">
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <div mat-dialog-title class="matp-dialog-title">
    {{ notification.title }}
  </div>

  <mat-dialog-content
    class="!tw-flex tw-flex-col tw-w-full tw-max-h-1/2 !tw-pt-1 tw-text-black"
  >
    <markdown
      ngPreserveWhitespaces
      [data]="notification.content"
      class="question-text"
    >
      # Markdown
    </markdown>
    <div class="tw-mt-5">
      投稿日時：{{ notification.releaseAt | date: " yyyy/MM/dd HH:mm" }}
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4 tw-text-black"
  >
    <button
      id="btn-cancel-add-account"
      mat-raised-button
      mat-dialog-close
      class="tw-w-40"
    >
      <mat-icon>close</mat-icon>
      閉じる
    </button>
  </mat-dialog-actions>
</div>
